import React, { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import api from "../../../services/api";
import toastError from "../../../errors/toastError";
import { MAX_THIRD_PARTY_CHARS, friendlyErrorMessage } from "./helpers";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: { marginTop: theme.spacing(1) },
  label: { fontSize: 12, color: theme.palette.text.secondary },
  value: { whiteSpace: "pre-wrap", wordBreak: "break-word" },
  actions: { marginTop: theme.spacing(0.5), display: "flex", gap: theme.spacing(1) },
}));

/** Terceiro envolvido: texto puro + edição por PATCH /ocorrencias/:id/terceiro (vazio limpa). */
const ThirdPartyBox = ({ occurrence, onUpdated }) => {
  const classes = useStyles();
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  const startEdit = () => {
    setValue(occurrence.thirdPartyInfo || "");
    setEditing(true);
  };

  const save = async () => {
    const trimmed = value.trim();
    if (!trimmed && occurrence.thirdPartyInfo) {
      if (!window.confirm("Remover as informações do terceiro envolvido?")) return;
    }
    setSaving(true);
    try {
      const { data } = await api.patch(`/ocorrencias/${encodeURIComponent(occurrence.id)}/terceiro`, {
        thirdPartyInfo: trimmed,
      });
      onUpdated(data);
      setEditing(false);
    } catch (err) {
      const friendly = friendlyErrorMessage(err);
      if (friendly) toast.error(friendly);
      else toastError(err);
    }
    setSaving(false);
  };

  return (
    <div className={classes.root}>
      <span className={classes.label}>Terceiro envolvido</span>
      {editing ? (
        <>
          <TextField
            fullWidth
            multiline
            minRows={2}
            variant="outlined"
            size="small"
            placeholder="Nome e telefone"
            value={value}
            disabled={saving}
            inputProps={{ maxLength: MAX_THIRD_PARTY_CHARS }}
            helperText={`${value.length}/${MAX_THIRD_PARTY_CHARS}`}
            onChange={(event) => setValue(event.target.value)}
          />
          <div className={classes.actions}>
            <Button size="small" variant="contained" color="primary" disabled={saving} onClick={save}>
              {saving ? <CircularProgress size={16} color="inherit" /> : "Salvar"}
            </Button>
            <Button size="small" disabled={saving} onClick={() => setEditing(false)}>
              Cancelar
            </Button>
          </div>
        </>
      ) : (
        <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
          <Typography variant="body2" className={classes.value} style={{ flex: 1 }}>
            {occurrence.thirdPartyInfo || "—"}
          </Typography>
          <Button size="small" onClick={startEdit}>
            Editar
          </Button>
        </div>
      )}
    </div>
  );
};

export default ThirdPartyBox;
